export const BIZNET_TYPES_RESET_STATE = 'BIZNET_TYPES_RESET_STATE';
export const BIZNET_TYPES_CURRENT_ITEM = 'BIZNET_TYPES_CURRENT_ITEM';

export const BIZNET_TYPES_REQUEST_LOADING = 'BIZNET_TYPES_REQUEST_LOADING';
export const BIZNET_TYPES_REQUEST_SUCCESS = 'BIZNET_TYPES_REQUEST_SUCCESS';
export const BIZNET_TYPES_REQUEST_FAILED = 'BIZNET_TYPES_REQUEST_FAILED';

export const BIZNET_TYPES_CURRENT_ACTION = 'BIZNET_TYPES_CURRENT_ACTION';
export const BIZNET_TYPES_RESET_ACTION = 'BIZNET_TYPES_RESET_ACTION';